var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2153_16720)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_16720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 21C29.6456 21 29.2956 21.0612 28.9631 21.1793L16.6913 25.6086C16.2756 25.7616 16 26.1551 16 26.5967C16 27.0384 16.2756 27.4319 16.6913 27.5849L19.2244 28.4988C18.5069 29.6268 18.1 30.9604 18.1 32.364V33.5927C18.1 34.8344 17.6275 36.1156 17.1244 37.1256C16.84 37.694 16.5163 38.2537 16.14 38.7696C16 38.9577 15.9606 39.2025 16.0394 39.4255C16.1181 39.6485 16.3019 39.8147 16.5294 39.8715L19.3294 40.5711C19.5131 40.6192 19.71 40.5842 19.8719 40.4836C20.0338 40.3831 20.1475 40.2169 20.1825 40.0289C20.5588 38.1575 20.3706 36.4785 20.0906 35.276C19.9506 34.6552 19.7625 34.0212 19.5 33.4396V32.364C19.5 31.0435 19.9463 29.7974 20.7206 28.8005C21.285 28.1227 22.0156 27.5762 22.8731 27.2395L29.7419 24.5417C30.1006 24.4018 30.5075 24.5767 30.6475 24.9352C30.7875 25.2937 30.6125 25.7004 30.2538 25.8403L23.385 28.5381C22.8425 28.7524 22.3656 29.0803 21.9763 29.4826L28.9588 32.0011C29.2913 32.1191 29.6413 32.1804 29.9956 32.1804C30.35 32.1804 30.7 32.1191 31.0325 32.0011L43.3088 27.5849C43.7244 27.4362 44 27.0384 44 26.5967C44 26.1551 43.7244 25.7616 43.3088 25.6086L31.0369 21.1793C30.7044 21.0612 30.3544 21 30 21ZM21.6 37.4404C21.6 38.9839 25.3625 40.5886 30 40.5886C34.6375 40.5886 38.4 38.9839 38.4 37.4404L37.7306 31.0829L31.5094 33.3303C31.0238 33.5052 30.5119 33.5927 30 33.5927C29.4881 33.5927 28.9719 33.5052 28.4906 33.3303L22.2694 31.0829L21.6 37.4404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_16720",
    x1: 10,
    y1: 9.5,
    x2: 49.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9609E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_16720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.be0016ee6e88eb306febcb4e42ddffbe.svg";
export { ForwardRef as ReactComponent };